import { useTranslation } from 'react-i18next';
import {
  IcoMail, IcoPhone, IcoMapPin,
  IcoFacebook, IcoInstagram, IcoLinkedIn, IcoYoutube, IcoWhatsApp
} from '../../assets/icons';

const socials = [
  { Icon: IcoFacebook,  label: 'Facebook',  href: '#' },
  { Icon: IcoInstagram, label: 'Instagram', href: '#' },
  { Icon: IcoLinkedIn,  label: 'LinkedIn',  href: '#' },
  { Icon: IcoYoutube,   label: 'YouTube',   href: '#' },
  { Icon: IcoWhatsApp,  label: 'WhatsApp',  href: 'https://wa.me/244923000000' },
];

export default function Footer({ onNavigate }) {
  const { i18n } = useTranslation();
  const isPt = i18n.language === 'pt';
  const year = new Date().getFullYear();

  const cols = [
    {
      head_pt: 'Fundação',
      head_en: 'Foundation',
      links: [
        { pt: 'Quem Somos',          en: 'About Us',            href: '/quem-somos' },
        { pt: 'Missão e Visão',      en: 'Mission & Vision',    href: '/quem-somos' },
        { pt: 'A Fundadora',         en: 'The Founder',         href: '/quem-somos' },
        { pt: 'Áreas de Actuação',   en: 'Areas of Action',     href: '/quem-somos' },
        { pt: 'Transparência',       en: 'Transparency',        href: '/quem-somos' },
      ],
    },
    {
      head_pt: 'Programas',
      head_en: 'Programmes',
      links: [
        { pt: 'PDIC',               en: 'PDIC',                 href: '/programas' },
        { pt: 'Tata Uhayele',       en: 'Tata Uhayele',         href: '/programas' },
        { pt: 'Seja Mulher',        en: 'Seja Mulher',          href: '/programas' },
        { pt: 'Campus Juventude',   en: 'Youth Campus',         href: '/programas' },
        { pt: 'Dikota E6.0',        en: 'Dikota E6.0',          href: '/programas' },
        { pt: 'Ver todos',          en: 'View all',             href: '/programas' },
      ],
    },
    {
      head_pt: 'Participar',
      head_en: 'Participate',
      links: [
        { pt: 'Acções Sociais',     en: 'Social Actions',       href: '/accoes'    },
        { pt: 'Impacto',            en: 'Impact',               href: '/impacto'   },
        { pt: 'Parceiros',          en: 'Partners',             href: '/parceiros' },
        { pt: 'Voluntariado',       en: 'Volunteering',         href: '/contacto'  },
        { pt: 'Contacto',           en: 'Contact',              href: '/contacto'  },
      ],
    },
  ];

  return (
    <footer className="bg-brand-950 text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="py-16 grid grid-cols-1 lg:grid-cols-5 gap-12">

          {/* Brand — 2 cols */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-5">
              <img
                src="/fdc-logo.png"
                alt="Fundação Ngana Zenza"
                className="h-10 w-auto flex-shrink-0"
                style={{ filter: 'brightness(0) invert(1)' }}
              />
              <div className="leading-tight">
                <div className="text-[10px] font-semibold text-white/50 uppercase tracking-[0.15em]">Fundação</div>
                <div className="text-base font-bold text-white">Ngana Zenza</div>
                <div className="text-[9px] text-white/40 uppercase tracking-widest mt-0.5">
                  {isPt ? 'Para o Desenvolvimento Comunitário' : 'For Community Development'}
                </div>
              </div>
            </div>

            <p className="text-sm text-white/60 leading-relaxed max-w-xs">
              {isPt
                ? 'Organização filantrópica angolana criada a 20 de Fevereiro de 2020 pela Primeira-Dama Ana Dias Lourenço.'
                : 'Angolan philanthropic organisation created on 20 February 2020 by First Lady Ana Dias Lourenço.'}
            </p>

            {/* Socials */}
            <div className="flex items-center gap-2 mt-6">
              {socials.map(({ Icon, label, href }) => (
                 <a
                  key={label}
                  href={href}
                  aria-label={label}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="p-2.5 rounded-xl bg-white/10 hover:bg-white/20 text-white/60 hover:text-white transition-all duration-200"
                >
                  <Icon cls="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          {/* Link columns — 3 cols */}
          {cols.map((col, ci) => (
            <div key={ci}>
              <h4 className="text-[11px] font-bold text-white uppercase tracking-[0.12em] mb-5 pb-2 border-b border-white/10">
                {isPt ? col.head_pt : col.head_en}
              </h4>
              <ul className="space-y-3">
                {col.links.map((link, li) => (
                  <li key={li}>
                    <button
                      onClick={() => onNavigate && onNavigate(link.href)}
                      className="text-sm text-white/55 hover:text-white transition-colors text-left"
                    >
                      {isPt ? link.pt : link.en}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Contact strip */}
        <div className="py-6 border-t border-white/10 grid sm:grid-cols-3 gap-5">
          {[
            { Icon: IcoMapPin, label: isPt ? 'Sede' : 'HQ',       val: 'Luanda, Angola. Rua Rainha Ginga, Torre ElySee 8º Andar.',  href: null },
           { Icon: IcoPhone, label: isPt ? 'Telefone' : 'Phone', val: '+244 925 700 016 / +244 925 700 017', href: 'tel:+244925700016' },
            { Icon: IcoMail,   label: 'Email',                      val: 'geral@fdc.ao',      href: 'mailto:geral@fdc.ao' },
          ].map(({ Icon, label, val, href }, i) => (
            <div key={i} className="flex items-center gap-3">
              <div className="w-8 h-8 rounded-lg bg-white/10 flex items-center justify-center flex-shrink-0 text-white/50">
                <Icon cls="w-4 h-4" />
              </div>
              <div>
                <p className="text-[10px] text-white/40 uppercase tracking-wider">{label}</p>
                {href
                  ? <a href={href} className="text-sm text-white/70 hover:text-white transition-colors font-medium">{val}</a>
                  : <p className="text-sm text-white font-medium">{val}</p>
                }
              </div>
            </div>
          ))}
        </div>

        {/* Bottom bar */}
        <div className="py-5 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-[11px] text-white/35">
            © {year} Fundação Ngana Zenza para o Desenvolvimento Comunitário.{' '}
            {isPt ? 'Todos os direitos reservados.' : 'All rights reserved.'}
          </p>
          <div className="flex items-center gap-5">
            {[
              { pt: 'Política de Privacidade', en: 'Privacy Policy' },
              { pt: 'Transparência',           en: 'Transparency'  },
            ].map((l, i) => (
              <button key={i} className="text-[11px] text-white/35 hover:text-white transition-colors">
                {isPt ? l.pt : l.en}
              </button>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}